/** Matches Backend/validators/saas.validators.js */
export const PASSWORD_REGEX =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#^()_+\-=[\]{};':"\\|,.<>/?]).{8,}$/;

export const PASSWORD_HINT =
  "At least 8 characters with uppercase, lowercase, a number, and a special character (e.g. @ # !)";

export function formatInrFromPaise(paise) {
  if (!paise) return "Contact us";
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
  }).format(paise / 100);
}

export function validateRegistrationForm(values) {
  const errors = {};
  if (!values.company_name?.trim()) errors.company_name = "Company name is required";
  if (!values.email?.trim()) errors.email = "Email is required";
  if (!/^[6-9]\d{9}$/.test(String(values.mobile || "").replace(/\D/g, "").slice(-10))) {
    errors.mobile = "Valid 10-digit mobile required";
  }
  if (!values.password) {
    errors.password = "Password is required";
  } else if (!PASSWORD_REGEX.test(String(values.password))) {
    errors.password = PASSWORD_HINT;
  }
  if (!values.plan_slug) errors.plan_slug = "Select a plan";
  return errors;
}

export function mapApiErrors(apiErrors) {
  const mapped = {};
  if (!Array.isArray(apiErrors)) return mapped;
  for (const item of apiErrors) {
    if (item?.field) mapped[item.field] = item.message;
  }
  return mapped;
}
